import { useState, useMemo } from 'react';
import { CodeName } from 'components/common/types/CodeName.types';
import { InputValidationConfig } from '../InputWithValidation';

const INITIAL_CREATIVE_INPUT_CONFIG: InputValidationConfig = {
  elementConfig: {
    type: 'text',
    placeholder: 'Enter creative ID',
    name: 'externalId',
  },
  value: '',
  label: '',
  validations: {
    required: {
      value: true,
      error: false,
      message: 'Enter creative ID',
    },
  },
  valid: false,
  touched: false,
};

type GetSetState<T> = {
  get: T;
  set: (value: T) => void;
};

type UseFormState = {
  dsp: GetSetState<CodeName>;
  externalId: GetSetState<InputValidationConfig>;
  dealId: GetSetState<CodeName[]>;
  filesList: GetSetState<File[]>;
  fileName: GetSetState<string>;
  isSubmitDisabled: GetSetState<boolean>;
  isFormValid: boolean;
};

export const useFormState = (): UseFormState => {
  const [dsp, setDsp] = useState<CodeName>({} as CodeName);
  const [externalId, setExternalId] = useState<InputValidationConfig>(INITIAL_CREATIVE_INPUT_CONFIG);
  const [dealId, setDealId] = useState<CodeName[]>([]);
  const [filesList, setFilesList] = useState<File[]>([]);
  const [fileName, setFileName] = useState<string>('');
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(false);

  const isFormValid = useMemo(() => {
    return !!(dsp.code && externalId.value.trim() && filesList.length > 0);
  }, [dsp.code, externalId.value, filesList.length]);

  return {
    dsp: {
      get: dsp,
      set: setDsp,
    },
    externalId: {
      get: externalId,
      set: setExternalId,
    },
    dealId: {
      get: dealId,
      set: setDealId,
    },
    filesList: {
      get: filesList,
      set: setFilesList,
    },
    fileName: {
      get: fileName,
      set: setFileName,
    },
    isSubmitDisabled: {
      get: isSubmitDisabled,
      set: setIsSubmitDisabled,
    },
    isFormValid,
  };
};
